import { cloneDeep, get } from "lodash";

export default {
  validateAreaGuoshoucai(submitParams = {}) {
    
    // console.log('🚀 ~ submitParams:', submitParams);
    const { groupApplicant = {}, groupName, personsInfo } = submitParams;
    const { insureDistrict, insureHouseCity } = groupApplicant;
    let areaCode = insureDistrict
    let cityCode = insureHouseCity;
    let groupNameValue = groupName;
    if (this.isQuotePage) {
      // 报价页获取地址
      const selectedDistrict = get(
        this.quoetEnterprise.find(item => item.prop === 'groupApplicant.insureHouseAddress'),
        'selected'
      );
      const selectedGroupName = get(
        this.quoetEnterprise.find(item => item.prop === 'groupName'),
        'selected'
      );
      areaCode = get(selectedDistrict, 'area.code', '');
      cityCode = get(selectedDistrict, 'city.code', '');
      groupNameValue = selectedGroupName;
    }
    if (areaCode + '' === '320581' || areaCode + '' === '320582') {
      if (this.isQuotePage) {
        const hasNot12JobType = this.quoetPlanDate.find(item => {
          return item.professionList.some(profession => {
            return profession.professions.val !== '1' && profession.professions.val !== '2'
          })
        })
        if (hasNot12JobType) {
          return '注册地或营业地在江苏省-苏州市-常熟市及张家港市地区的企业团体，仅限投保1-2类职业';
        }
      } else if (
        personsInfo.some(
          (person) => person.occupationTypeVal !== '1' && person.occupationTypeVal !== '2'
        )
      ) {
        return '注册地或营业地在江苏省-苏州市-常熟市及张家港市地区的企业团体，仅限投保1-2类职业';
      }
    }
    if (cityCode + '' === '440700') {
      if (['家具', '家俱', '木材'].some((keyword) => groupNameValue.includes(keyword))) {
        return '注册地或营业地在广东省-江门市地区的家具木材制造业不允许投保';
      }
    }
    return '';
  },
};

/**
 * 80291 意外医疗社保内费用赔付比例与意外医疗社保内费用相关联，若意外医疗不投保，该责任不展示
 * @param {*} clauses
 * @returns
 */
export const filterClauses80291 = (clauses) => {
  // 意外医疗社保内费用
  const ywylsbnfyClauseCode = 'GP8029124194320';
  // 意外医疗社保内费用赔付比例
  const ywylsbnfypfblClauseCode = 'GP8029105528501';
  // 意外医疗扩展社保外费用
  const ywylkzsbwfyClauseCode = 'GP8029156009323';
  const cloneClauses = cloneDeep(clauses);
  const ywylsbnfyClause = cloneClauses.find((clause) => clause.clauseCode === ywylsbnfyClauseCode);
  // 若意外医疗不投保，则意外医疗社保内费用赔付比例不展示
  const ywylsbnfypfblClause = cloneClauses.find((clause) => clause.clauseCode === ywylsbnfypfblClauseCode);
  // 若意外医疗不投保，则意外医疗扩展社保外费用也不展示
  const ywylkzsbwfyClause = cloneClauses.find((clause) => clause.clauseCode === ywylkzsbwfyClauseCode);
  if (ywylsbnfyClause.selected.value == 0) {
    // 意外医疗社保内费用赔付比例不展示的时候默认是 80%
    ywylsbnfypfblClause.selected = ywylsbnfypfblClause.optionList.find((option) => option.name === '80%');
    ywylkzsbwfyClause.selected = ywylkzsbwfyClause.optionList.find((option) => option.value == '0');
    ywylsbnfypfblClause.hidden = true
    ywylkzsbwfyClause.hidden = true
  } else {
    delete ywylsbnfypfblClause.hidden
    delete ywylkzsbwfyClause.hidden
  }
  return cloneClauses;
};

/**
 * 80324 【意外医疗扩展社保外费用】与【意外医疗社保内费用】相关联，若【意外医疗社保内费用】不投保，则【意外医疗扩展社保外费用】不展示
 * 同80291，只是责任code不一样
 * @param {*} clauses
 * @returns
 */
export const filterClauses80324 = (clauses) => {
  // 意外医疗社保内费用
  const ywylsbnfyClauseCode = 'GP8032424195343';
  // 意外医疗扩展社保外费用
  const ywylkzsbwfyClauseCode = 'GP8032456008300';
  const cloneClauses = cloneDeep(clauses);
  const ywylsbnfyClause = cloneClauses.find((clause) => clause.clauseCode === ywylsbnfyClauseCode);
  // 若【意外医疗社保内费用】不投保，则【意外医疗扩展社保外费用】不展示，社保外费用默认不投保
  const ywylkzsbwfyClause = cloneClauses.find((clause) => clause.clauseCode === ywylkzsbwfyClauseCode);
  if (ywylsbnfyClause.selected.value == 0) {
    ywylkzsbwfyClause.selected = ywylkzsbwfyClause.optionList.find((option) => option.value == '0');
    ywylkzsbwfyClause.hidden = true
  } else {
    delete ywylkzsbwfyClause.hidden
  }
  return cloneClauses;
};


// WEBPACK FOOTER //
// ./src/mixin/special/special-80291.js